import { Pipe, PipeTransform } from '@angular/core';
import { DatesUtil } from '@shared/utilities/dates/dates.util';

@Pipe({
  name: 'taskDueDate',
})
export class TaskDueDatePipe implements PipeTransform {
  transform(date: string): Date {
    return DatesUtil.convertToDate(date) ?? new Date();
  }
}